
import { AfterViewChecked, Component, OnInit, ViewChild, HostListener} from '@angular/core';
import { } from 'googlemaps';

var map;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent{

  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  screenWidth: any;
  resizedWidth = false; 



  constructor() {
    this.getScreenSize();
  }
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
      this.screenWidth = window.innerWidth;
      console.log(this.screenWidth);
      if(this.screenWidth > 1199){
        this.resizedWidth = true;
      }
  }

  ngAfterViewChecked() {
    if(this.resizedWidth) {
      this.getGoogleMaps(); 
      this.resizedWidth = false; 
    }
  }

  ngAfterViewInit(){
    this.getGoogleMaps();
  }
  
  getGoogleMaps() {

    var mapProp = {
      center: new google.maps.LatLng(35.745616, -78.794140),
      zoom: 14,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);

    var contentString = '<div id="content">'+
    '<div id="siteNotice">'+
    '</div>'+
    '<h6 id="firstHeading" class="firstHeading">MacGregor Downs Country Club</h6>'+
    '<div id="bodyContent">'+
    '<p>430 St Andrews Ln <br>'+
    'Cary, NC 27511</p>'+
    '<p><a href="https://goo.gl/maps/aL2D9cWzpWAp3nkC6" target="blank">'+
    'View on Google Maps</a> </p>'+
    '</div>'+
    '</div>';

    var infowindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 200
    });

    var marker = new google.maps.Marker({
      position: {lat: 35.745616, lng: -78.794140 },
      map: map,
      title: 'MacGregor Downs Country Club'
    });

    marker.addListener('click', function() {
      infowindow.open(map, marker);
    });
  }

  
}
